import { ROUTES } from "../../../routes/patientRoutes/routePaths";
import Cookies from "js-cookie";

export function handleLoginNavigate(data, navigate, email) {
  if (!data) return console.error("Missing data in login navigation");

  const payloadUser = data?.user ?? data?.data?.user ?? data?.data ?? null;
  const userId =
    payloadUser?.id ||
    payloadUser?._id ||
    data?.userId ||
    data?.id ||
    data?.data?.id ||
    null;
  const accessToken =
    data?.accessToken ||
    data?.token ||
    data?.data?.accessToken ||
    null;

  if (userId && !accessToken) {
    sessionStorage.setItem(
      "patientTwoFactorChallenge",
      JSON.stringify({ userId, email, createdAt: Date.now() }),
    );
    return navigate(ROUTES.VERIFY_CODE, {
      state: { userId, email },
      replace: true,
    });
  }

  // ------ Login finished successfully ------
  if (!userId || !accessToken) {
    console.warn("Login result missing valid user or token; staying on auth flow.", {
      userId,
      hasAccessToken: Boolean(accessToken),
      payload: data,
    });
    return;
  }

  // Persist only when the backend actually provided the session data.
  Cookies.set("accessToken", accessToken);
  Cookies.set("id", userId);

  // Redirect to feed
  navigate(ROUTES.FEED(userId), { replace: true });
}
